import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"

import axios from 'axios';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControlLabel, Popover, RadioGroup, Radio, Slider, Switch } from '@mui/material';
import {CcLoader, InfoToolTip, LionLoaderGradient, TabSelector} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {InputText, InputNumber, InputURL, FileSelector, LionListbox, CcCheckbox} from '../commonComponents/inputFields'
import {MaxIntInArray, RandomInt, RandomGradientPairHex, RandomGradientHex, TryParseIntDefault} from "../components/helpers";
import { Icon as Iconify } from '@iconify/react';


import { getErrorListFromYupError, getErrorMessage, snippetDataChartsValidationSchema } from '../components/helperErrors'
import { lionIcons } from '../components/helpersIcons';
import { Helmet } from 'react-helmet';
import { CcActionButton, CcActionButtonOutlined, CcSecondaryActionButtonOutlined, CcSubSectionTitle, CcTitle } from '../commonComponents/styledTexts';
import { string } from 'yup';
import { LionColorPicker } from '../components/lionColorPicker';
import { DatafeedPicker } from '../components/datafeedGrid';
import { DatabindingSelector } from '../components/templateEditor';

const BarcodesGallery = (props) => {
  const [selectedBarCode, setSelectedBarCode] = useState(undefined)
  const [barcodes, setBarcodes] = useState([])

  useEffect(() => {
    getAvailableBarcodes()
   
  }, [])

    const getAvailableBarcodes = async () => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Barcodes/gallery`;
        const response = await axios.get(url);

        setBarcodes(response.data);
        handleSelectedBarcodeChange("QR")

      } catch (error) {
        console.log(error);
      }
      
    }

  const handleSelectedBarcodeChange = (code) => {
    //console.log(code)
    setSelectedBarCode(code)
    if (props.onChange) props.onChange(code)
  }
 
    return <div className='grid grid-cols-2 font-poppins text-ccColorDarkTeal'>
        <div>
            <div className='text-xl font-semibold'>1D Barcodes</div>
            <div className='flex flex-row flex-wrap gap-4 '>
                    {barcodes.filter(b => b.barcodeType === 'Barcode1D').map((m, index) => <div className={`w-fit flex flex-col items-center border border-ccColorDarkTeal p-2 rounded hover:bg-slate-200 hover:cursor-pointer ${selectedBarCode === m.code ? 'border-2 bg-teal-50' : ''}`} onClick={()=>handleSelectedBarcodeChange(m.code)}> 
                        <div className='text-lg font-semibold'>{m.title}</div>
                        <img src={m.imgDataUrl} />
                    </div>)}
            </div>
        </div>
        <div>
            <div className='text-xl font-semibold'>2D Barcodes</div>
            <div className='flex flex-row flex-wrap gap-4 '>
                    {barcodes.filter(b => b.barcodeType === 'Barcode2D').map((m, index) => <div className={`w-fit flex flex-col items-center border border-ccColorDarkTeal p-2 rounded hover:bg-slate-200 hover:cursor-pointer ${selectedBarCode === m.code ? 'border-2 bg-teal-50' : ''}`} onClick={()=>handleSelectedBarcodeChange(m.code)}> 
                        <div className='text-lg font-semibold'>{m.title}</div>
                        <img src={m.imgDataUrl} />
                    </div>)}
            </div>
        </div>
    </div>
}

export function BarcodeElementManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetHref, setSnippetHref] = useState('')



  useEffect(() => {
    //console.log(props.snippetInfo)
    if (props.snippetInfo === undefined && settings === undefined) return;

    if (props.snippetInfo) { //we are in edit
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetHref(props.snippetInfo.href)
    }
    else {

    }

  }, [props.templateId, props.snippetInfo, props.resourcesByLanguage, settings])



  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 23,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};
    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.href = snippetHref;
 
    if (updatePropName) {
      result[updatePropName] = updatePropValue;
      //console.log(result)
  }
    return result;
  }

  const handleFallbackImageChange = (dataURL) => {

    const newSettings = {...props.fallback, fallbackImage: dataURL}
    if (props.onFallbackChange) props.onFallbackChange(newSettings)
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
  const handleSnippetHrefChange = (newValue) => {
    
    setSnippetHref(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('href', newValue))
  }
  const handleFallbackTypeChange = (fType) => {
    if (props.onFallbackChange) props.onFallbackChange({fallbackType: fType, fallbackImage: ''})
  }

  return <div>
  <div className='flex flex-col gap-4 justify-center items-center'>
      <div className=" w-1/2 mt-10 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
    <div className="sm:col-span-3">
      <InputText
              displayName="Element name"
              value={snippetName}
              onChange={(val) => {handleSnippetNameChange(val);}}
              error={getErrorMessage(props.validationErrorsList, 'snippetName')}
      />
    </div>

    <div className="sm:col-span-3">
      <InputText
                displayName="Description"
                value={snippetDesc}
                onChange={(val) => {handleSnippetDescChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
      />
    </div>


    <div className="sm:col-span-6">
      <div  className="text-sm font-poppins font-medium text-gray-900">Href</div>
      <InputURL
                value={snippetHref}
                onChange={(val) => {handleSnippetHrefChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'href')}
              />
    </div>  

  <div className="sm:col-span-6">
    <div className='font-semibold text-lg'>Fallback</div>
    <div class="inline-flex rounded-md shadow-sm font-poppins text-ccColorDarkTeal" role="group">
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.fallback?.fallbackType === 'showImage' ? 'bg-gray-200' : 'bg-white'}`}
            onClick={() => handleFallbackTypeChange('showImage')}>
        <div>
          Default Image
        </div>
        <div className='text-sm mt-2 font-normal'>Show your uploaded image</div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${props.fallback?.fallbackType === 'hide' || props.fallback == undefined ? 'bg-gray-200' : 'bg-white'}`}
          onClick={() => handleFallbackTypeChange('hide')}>
        <div>
          Collapse
        </div>
        <div className='text-sm mt-2 font-normal'>Hide the chart completely</div>
      </div>
    </div>

    {props.fallback?.fallbackType === 'showImage' && <>
      <div className='mt-2 flex flex-row gap-2 items-center'>
        <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
            Default Image
        </label>
        <InfoToolTip
        placement='right'
        headLine='MPP'
        message="You can optionally show this image instead of the chart any time the chart can't be generated. For example when the merged data is corrupted."
        />
      </div>
      <div className="sm:col-span-6">
        <FileSelector noDeleteButton
          onChange={handleFallbackImageChange}
          base64={props.fallback?.fallbackImage.length > 0 ? props.fallback?.fallbackImage.split(',')[1] : undefined}
          />
      </div>
      {props.fallbackImageError && <div className='text-red-500'>Please provide an image</div>}
    </>}

  </div>

</div>

</div>

  </div>
}


const BarcodeStyleSelector = (props) => {

  const [previewLoading, setPreviewLoading] = useState(false);
  const [availableStyles, setAvailableStyles] = useState([])
  const [selectedBarCodeTitle, setSelectedBarCodeTitle] = useState('')

  useEffect(() => {
    if(props.selectedBarCodeType) {
        getPredefinedStyles(props.selectedBarCodeType)
    }
  }, [props.selectedBarCodeType])

  const getPredefinedStyles = async (barCode) => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Barcodes/styles/${barCode}`;
      
      const response = await axios.get(url)
      setAvailableStyles(response.data)
      handleBarcodeChange(response.data[0])

      setPreviewLoading(false);

    } catch (error) {
      setPreviewLoading(false);
      console.log(error);
    }
  }
  const handleBarcodeChange = (barCode) => {
    setSelectedBarCodeTitle(barCode.title)
    if (props.onChange) props.onChange(barCode)
  }
  


  return <div>
            <CcSubSectionTitle>Select a predefined style and fine tune later</CcSubSectionTitle>
            <div className='flex flex-row flex-wrap gap-4 font-poppins text-ccColorDarkTeal'>
                    {availableStyles.map((s) => <div className={`w-fit flex flex-col items-center border border-ccColorDarkTeal p-2 rounded hover:bg-slate-200 hover:cursor-pointer ${selectedBarCodeTitle === s.title ? 'border-2 bg-teal-50' : ''}`} onClick={()=>handleBarcodeChange(s)}> 
                        <div className='text-lg font-semibold'>{s.title}</div>
                        <img src={s.imgDataUrl} />
                        <div className='w-full flex flex-col mt-1 text-sm'>
                            {s.descriptionLines.map(d => <div>{d}</div>)}
                        </div>
                    </div>)}
            </div>



  </div>

}
const DataBindindPrettyLabel = (props) => {
  const [prettyLabel, setPrettyLabel] = useState("")
  const [prettyLabelValue, setPrettyLabelValue] = useState("")

  useEffect(() => {
    if (props.dataBindType == undefined || props.dataBindValue == undefined) {
        setPrettyLabel("Same as design time")
        setPrettyLabelValue("")
        return
    }

    switch (props.dataBindType) {
      case "databind":
        setPrettyLabel("From feed:")
        setPrettyLabelValue(props.dataBindValue)
        break;
      case "urlChartSeries":
        setPrettyLabel("From URL parameter:")
        setPrettyLabelValue(props.dataBindValue)
        break;
      default:
        setPrettyLabel("Same as design time")
        setPrettyLabelValue("")
    }
    
  }, [props.dataBindType, props.dataBindValue])

  return <div className='border border-ccColorTeal rounded font-poppins px-2 py-1 text-sm flex flex-row items-center gap-x-1'>
    <div>{prettyLabel}</div>
    {prettyLabelValue.length > 0 && <div className='bg-slate-200 rounded px-1'>{prettyLabelValue}</div>}
    </div>
}


const BarCodeEditor = (props) => {
  const [allCodes, setAllCodes] = useState([])
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewImageDataUrl, setPreviewImageDataUrl] = useState('')
  const [sampleData, setSampleData] = useState({});
  const [dataConnectionInfo, setDataConnectionInfo] = useState(undefined);
  const [radioDatabindType, setRadioDatabindType] = useState('none');

  const shapes = [{id: 'Square', name: 'Square'}, {id: 'Circle', name: 'Circle'}, {id: 'DotGrid', name: 'Dot Grid'}, {id: 'Diamond', name: 'Diamond'}, {id: 'Wave', name: 'Wave'}]
  const gradientTypes = [{id: 'Horizontal', name: 'Horizontal'}, {id: 'Vertical', name: 'Vertical'}, {id: 'Diagonal Down', name: 'Diagonal Down'}, {id: 'DiagonalUp', name: 'Diagonal Up'}, {id: 'Radial', name: 'Radial'}]

  useEffect(() => {
    if (props.metadata) {
      const t = setTimeout(() => {
          getBarcodePreview();
        }, 250); // tune: 150–500ms is common

      return () => clearTimeout(t);      
    }
  }, [props.metadata])

  useEffect(() => {
    getAvailableBarcodes()
  }, [])

  const getAvailableBarcodes = async () => {
    
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Barcodes/gallery`;
      const response = await axios.get(url);

      //console.log(response.data)

      setAllCodes(response.data.map(c => {return {id: c.code, name: c.title}}));

    } catch (error) {
      console.log(error);
    }
    
  }
  const getBarcodePreview = async () => {
    setPreviewLoading(true)
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Barcodes/preview?payload=ciao`;
      const response = await axios.post(url, props.metadata);

      setPreviewImageDataUrl(response.data)

    } catch (error) {
      console.log(error);
    }
    finally{setPreviewLoading(false)}
    
  }
  const handleMetadataChange = (propName, propValue) =>
  {
    const newMetadata = {...props.metadata, [propName]: propValue}
    if (props.onChange) props.onChange(newMetadata)
  }

  const handleAttachFeedInfoToMetadata = (feedId) => {
    handleMetadataChange('ccFeedId', feedId)    
  }
  const getDataConnectionInfoAndSampleData = async (dataConnectionId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/Feeds/info/${dataConnectionId}`;
      let response = await axios.get(url);
      // let url = `api/Feeds/info/${dataConnectionId}`;
      // let response = await fetch(url, { method: "GET", });
      let data = response.data;

      //let data = await response.json();
      setDataConnectionInfo(data)
      //console.log(data)
      handleAttachFeedInfoToMetadata(data.feedId)

      // TODO ADD LOGIC TO FETCH SAMPLE DATA
      url = `${process.env.REACT_APP_LION_API_URL}/Feeds/sample/${dataConnectionId}`;
      response = await axios.get(url);
      // url = `api/Feeds/sample/${dataConnectionId}`;
      // response = await fetch(url, { method: "GET", });
      data = response.data;
  
      // data = await response.json();
      setSampleData(data);
      // console.log(response.data);  

    } catch (error) {
      console.log(error);
    }
  }
  const handleDataConnectionChange = (dataCon) => {
    //setDataConnection(dataCon)
    if (dataCon !== undefined) getDataConnectionInfoAndSampleData(dataCon.id);
    else {
      setDataConnectionInfo(undefined)
      setSampleData({});
      handleAttachFeedInfoToMetadata(undefined)
    }
  }
  const handleDatabindChange = (bindType, dataBindValue,) => {
    const newMetadata = {...props.metadata, ccDatabindType: bindType, ccDatabindValue: dataBindValue}
    
    //console.log(newMetadata)

    if (props.onChange) props.onChange(newMetadata)
  }


  return <div className='grid grid-cols-2'>
    <div>
      <div className='w-48'>
        <div className="block text-sm font-medium leading-6 text-gray-900">
          Barcode type
        </div>
        <LionListbox items={allCodes}
              selectedItemId={props.metadata?.barcodeType}
              //onChange={(item) => handleChange('verb', item.id)}
              zIndex={1}
              id="barcodetype"
              />
      </div>
      <div className='mt-2 w-[440px] border border-slate-200 rounded px-2 py-1 font-poppins text-ccColorDarkTeal'>
        <div className='font-semibold'>Payload</div>

<div className={`rounded ${radioDatabindType === 'none' ? 'border border-ccColorTeal': ''}`}>
        <label className="mt-2 flex cursor-pointer items-center gap-3">
          <input
            type="radio"
            className="peer sr-only"
            checked={radioDatabindType === 'none'}
            onChange={() => setRadioDatabindType("none")}
          />

          <span
            className="
              relative grid h-5 w-5 place-items-center rounded-full border border-slate-300 transition
              peer-checked:border-ccColorDarkTeal peer-checked:ring-4 peer-checked:ring-ccColorLightTeal
              after:content-[''] after:absolute after:h-2.5 after:w-2.5 after:rounded-full after:bg-ccColorDarkTeal after:scale-0 after:transition
              peer-checked:after:scale-100
            "
          />

          <span className="font-medium text-lg">Static</span>
        </label>
        <div className='ml-8 mt-1'>
          Static content
        </div>
</div>
        
        <label className="mt-2 flex cursor-pointer items-center gap-3">
          <input
            type="radio"
            className="peer sr-only"
            checked={radioDatabindType === 'url'}
            onChange={() => setRadioDatabindType("url")}
          />

          <span
            className="
              relative grid h-5 w-5 place-items-center rounded-full border border-slate-300 transition
              peer-checked:border-ccColorDarkTeal peer-checked:ring-4 peer-checked:ring-ccColorLightTeal
              after:content-[''] after:absolute after:h-2.5 after:w-2.5 after:rounded-full after:bg-ccColorDarkTeal after:scale-0 after:transition
              peer-checked:after:scale-100
            "
          />

          <span className="font-medium text-lg">URL Parameter</span>
        </label>
        <div className='ml-8 mt-1'>
          Url content
        </div>


        <div className='flex flex-row items-center gap-x-2'>
          <div className='text-sm'>Connect to a feed</div>
          <div className='border border-ccColorSecondaryPurple rounded w-fit'>
            <DatafeedPicker onDataConnectionChange={handleDataConnectionChange}
                            selectedDataconnectionId={props.metadata.ccFeedId}
            />        
          </div>
        </div>
      <div className='mt-2 flex flex-row items-center'>
        <DataBindindPrettyLabel
            dataBindType={props.metadata.ccDatabindType}
            dataBindValue={props.metadata.ccDatabindValue}
        />
        <DatabindingSelector dataBindValue={props.metadata.ccDatabindValue}
            sampleData={sampleData}
            noPreview
            dataBindType={props.metadata.ccDatabindType}
            dataBindTypes={props.metadata.ccFeedId ? ['none', 'databind'] : ['none', 'url']}
            onChange={handleDatabindChange}
        />
       </div>

      </div>

      {props.metadata?.barcodeType === 'QR' && <div>
          <div className='mt-2 flex flex-row items-end gap-x-1'>
            <div className='w-44'>
                <InputNumber displayName="Size (approximate)"
                min={32} max={800} incr={1}
                onChange={(val) => handleMetadataChange('width', val)}
                value={props.metadata?.width}
                />
            </div>
            <div className='mb-1'>
              <InfoToolTip
                //custom={<OneWordLabel />}
                placement='right'
                headLine={`QR size`}
                message="The final size could be a few pixels off. This might be necessary to generate a valid QR code"
              />  
            </div>
          </div>
          <div className='mt-2 w-[440px] bg-slate-100 rounded px-2 py-1 font-poppins text-ccColorDarkTeal'>
            <div className='font-semibold'>Eyes</div>
            <div className='flex flex-row gap-x-4'>
              <div className='mt-2 mb-2'>
                <div className='h-6 block text-sm font-medium text-gray-900'>Outer color</div>
                <LionColorPicker color={props.metadata?.eyesOuterColor}
                  onChange={(color) => handleMetadataChange('eyesOuterColor', color)}
                />
              </div>
              <div className='flex flex-row'>
                <div className='mt-2 mb-2'>
                  <div className='h-6 block text-sm font-medium text-gray-900'>Inner color</div>
                  <LionColorPicker color={props.metadata?.eyesInnerColor}
                    onChange={(color) => handleMetadataChange('eyesInnerColor', color)}
                  />
                </div>
              </div>
            </div>
          <div className='flex flex-row gap-x-4 mb-2'>
            <div className='w-48'>
              <div className="block text-sm font-medium leading-6 text-gray-900">
                Outer Shape
              </div>
              <LionListbox items={shapes}
                    selectedItemId={props.metadata?.eyesOuterShape}
                    onChange={(item) => handleMetadataChange('eyesOuterShape', item.id)}
                    zIndex={1}
                    id="eyesOuterShape"
                    />
            </div>
            <div className='w-48'>
              <div className="block text-sm font-medium leading-6 text-gray-900">
                Inner Shape
              </div>
              <LionListbox items={shapes}
                    selectedItemId={props.metadata?.eyesInnerShape}
                    onChange={(item) => handleMetadataChange('eyesInnerShape', item.id)}
                    zIndex={1}
                    id="eyesInnerShape"
                    />
            </div>
          </div>

          </div>

          <div className='mt-2 w-[440px] bg-slate-100 rounded px-2 py-1 font-poppins text-ccColorDarkTeal'>
            <div className='font-semibold'>Modules</div>
            <div className='mt-2 mb-2'>
              <div className='h-6 block text-sm font-medium text-gray-900'>Color</div>
              <LionColorPicker color={props.metadata?.foregroundColor}
                onChange={(color) => handleMetadataChange('foregroundColor', color)}
              />
            </div>
            <div className='w-48 mb-2'>
              <div className="block text-sm font-medium leading-6 text-gray-900">
                Shape
              </div>
              <LionListbox items={shapes}
                    selectedItemId={props.metadata?.moduleShape ? props.metadata.moduleShape : 'Square'}
                    onChange={(item) => handleMetadataChange('moduleShape', item.id)}
                    zIndex={1}
                    id="moduleShape"
                    />
            </div>

          </div>

          <div className='mt-2 w-[440px] bg-slate-100 rounded px-2 py-1 font-poppins text-ccColorDarkTeal'>
            <div className='font-semibold'>Background</div>
            <div className='flex flex-row gap-x-8 items-end'>
              <div className='mt-2'>
                <div className='block text-sm font-medium text-gray-900'>Color 1</div>
                <LionColorPicker color={props.metadata?.backgroundColor}
                    onChange={(color) => handleMetadataChange('backgroundColor', color)}
                />
              </div>
              <div className='mt-2'>
                <div className='flex flex-row items-center gap-x-2 -mb-1'>
                  <div className='block text-sm font-medium text-gray-900'>Color 2</div>
                  <FormGroup>
                  <FormControlLabel control={<Switch
                                              checked={props.useColorGradient}
                                              onChange={(e) => handleMetadataChange('useColorGradient', e.target.checked)}
                                              inputProps={{ 'aria-label': 'controlled' }}
                                              sx={{my: '-2px', '& .MuiSwitch-switchBase.Mui-checked': {color: '#357e86'},
                                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {backgroundColor:'#9bcccd'}}}
                                          />} label={<div className='font-poppins font-medium text-xs text-ccColorTeal'></div>}
                  />
                  </FormGroup>
                  <div className='-ml-6'>
                    <InfoToolTip 
                      placement='right'
                      headLine='Color gradient'
                      message={<div>Enable <span className='font-bold'>Color 2</span> to apply a gradient to this series</div>}
                    />
                  </div>
                </div>
                {props.metadata?.useColorGradient &&  <LionColorPicker color={props.metadata?.backgroundColorEnd}
                   onChange={(color) => handleMetadataChange('backgroundColorEnd', color)}
                />
                }
                {!props.metadata?.useColorGradient &&  <div className='h-10 flex items-center'>
                  <div className='font-poppins text-gray-500'>Not used</div>
                </div>
                }
              </div>

            </div>
            {props.metadata?.useColorGradient &&
            <div className='w-48 mt-2 mb-2'>
              <div className="block text-sm font-medium leading-6 text-gray-900">
                Gradient Type
              </div>
              <LionListbox items={gradientTypes}
                    selectedItemId={props.metadata?.gradientType}
                    onChange={(item) => handleMetadataChange('gradientType', item.id)}
                    zIndex={1}
                    id="moduleShape"
                    />
            </div>
            }

          </div>
        </div>
      }

    </div>

    <div>
      <div className='text-ccColorDarkTeal text-xl font-semibold font-poppins text-center'>Preview</div>
      {previewLoading && <div className='mt-8 flex flex-col gap-y-1 items-center font-poppins'> 
      <CcLoader size={96} />
      <div>Loading preview</div>
      </div>}
    
      {!previewLoading && <div className='flex justify-center'>
        <div className='overflow-auto max-w-[800px] mt-2 border-4 p-[4px] rounded border-slate-200'>
          <img className='max-w-none' src={previewImageDataUrl} />
        </div>
      </div>}
    </div>
  </div>
}

export default function BarcodeWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const [snippetData, setSnippetData] = useState({});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);
        
    const [selectedBarcodeMetadata, setSelectedBarcodeMetadata] = useState(undefined);
    const [selectedBarCodeType, setSelectedBarCodeType] = useState('QR'); //the type of barcode, which is selected in the first gallery
    const [isEdit, setIsEdit] = useState(false)
    const [showFallbackImageError, setShowFallbackImageError] = useState(false)
    const [openDialogWarning, setOpenDialogWarning] = useState(false)
    const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});

    const stepsForEdit = [{ name: 'Customize template', href: '#' },
                    { name: 'Configure Element', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]
    const stepsForNew = [{ name: 'Select barcode type', href: '#' },
                    { name: 'Customize barcode', href: '#' },
                    { name: 'Customize template', href: '#' },
                    { name: 'Configure Element', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]

    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
        setIsEdit(true)
      }
      else setIsEdit(false)
    }, [props.snippetId])


    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);

        const newSnippetData = response.data;
        const barcodeMetadata = JSON.parse(response.data.snippetSettings)
        setSelectedBarcodeMetadata(barcodeMetadata)
        
        //adding new metadata for compatibility with old tags that don't have it
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

    const submitDataSnippet = async () => {
      try {
        //console.log(snippetData)
        snippetDataChartsValidationSchema.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return false;
      }

      setShowLoader(true);
      setSuccessHtmlMsg('');
      setCurrentStep(currentStep+1)
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/23`;
          if (isEdit) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/23/${params.snippetId}`;
          
          const response = await axios.post(url, {...snippetData, snippetSettings: JSON.stringify({...selectedBarcodeMetadata})});
    
          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
  const handleChartElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataChartsValidationSchema.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }
  const handleChartElementFallbackChange = (fallbackInfo) => {
    const newChartMetadata = {...selectedBarcodeMetadata, ccFallback: fallbackInfo}
    setSelectedBarcodeMetadata(newChartMetadata)
    if (fallbackInfo.fallbackType === 'hide' || fallbackInfo.fallbackImage.length > 0) setShowFallbackImageError(false)
  }
      
  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Submit') {
          const valid = await submitDataSnippet()
          if (valid) setCurrentStep(navInfo.nextIndex);
      }
    else {
      if (currentStep === 1 && navInfo.nextIndex === 2) {
          setCurrentStep(navInfo.nextIndex);
      }
      else
        setCurrentStep(navInfo.nextIndex);
    }
  }
    
  const handleClose = () => {
      navigate("/ph/charts")
  }

  const handleSelectedBarcodeChange = (code) => {
    //this is only used when a barcode is selected from the gallery
    
    setSelectedBarCodeType(code)
  }
  const handleBarcodeSelectedStyleChange = (barcode) => {
    //this is only used when a barcode is selected from the barcode editor
    //in this case we want to set default size props
    const newMetadata = {...barcode.metadata, width: 256, height: 64}

    
    setSelectedBarcodeMetadata({...barcode, metadata: newMetadata})
  }
  const handleBarcodeMetadataChange = (metadata) => {
    
    setSelectedBarcodeMetadata({...selectedBarcodeMetadata, metadata: metadata})

  }

  const handleDialogClose = async(action) => {
    if (action === 'abort') {
      //do nothing
    }
    else if (action === 'ok') {
      //handleChartIdChangeDo(dialogData.id)
    }
    else if (action === 'proceed') {
      setCurrentStep(dialogData.nextStep)
    }

    setOpenDialogWarning(false);
  }

    return <div>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

        <CcStepper2
            steps={isEdit ? stepsForEdit : stepsForNew}
            currentStepIndex={currentStep}
        />
        {!isEdit &&
            <div className="border border-2 border-gray-200 rounded-md p-2">
                {currentStep === 0 && <div>
                    <BarcodesGallery onChange={handleSelectedBarcodeChange} />
                </div>}

                {currentStep === 1 && <BarcodeStyleSelector selectedBarCodeType={selectedBarCodeType} onChange={handleBarcodeSelectedStyleChange} />
                        
                }
                {currentStep === 2 && <BarCodeEditor metadata={selectedBarcodeMetadata.metadata} onChange={handleBarcodeMetadataChange} />}

                {currentStep === 3 && <BarcodeElementManager
                                        snippetInfo={snippetData}
                                        onChange={handleChartElementChange}
                                        onFallbackChange={handleChartElementFallbackChange}
                                        fallback={selectedBarcodeMetadata.ccFallback}
                                        fallbackImageError={showFallbackImageError}
                                        validationErrorsList={activeErrorList}
                  />}

                {currentStep === 4 && <div className='flex justify-center'>
                    {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                    {showLoader && <div className='mt-8'><CcLoader size={96} /></div> }
                    {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
                </div>}
                <StepperNavButtons totalSteps={4}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />

            </div>
        }
        {isEdit &&
            <div className="border border-2 border-gray-200 rounded-md p-2">
                {currentStep === 0 && <BarcodeStyleSelector selectedBarCode={selectedBarCodeType} onChange={handleBarcodeSelectedStyleChange} />
                        
                }
                {currentStep === 1 && <BarcodeElementManager
                                        snippetInfo={snippetData}
                                        onChange={handleChartElementChange}
                                        onFallbackChange={handleChartElementFallbackChange}
                                        fallback={selectedBarcodeMetadata.ccFallback}
                                        fallbackImageError={showFallbackImageError}
                                        validationErrorsList={activeErrorList}
                  />}

                {currentStep === 2 && <div className='flex justify-center'>
                    {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                    {showLoader && <div className='mt-8'><CcLoader size={96} /></div> }
                    {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
                </div>}
                <StepperNavButtons totalSteps={3}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />

            </div>
        }
      <Dialog onClose={() => handleDialogClose('abort')} open={openDialogWarning}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">{dialogData.title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="dialog-description">
              {dialogData.desc}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogClose('abort')}>Cancel</CcActionButton>
            <CcActionButton onClick={() => handleDialogClose(dialogData.action)} autoFocus>
              Confirm
            </CcActionButton>
          </DialogActions>
      </Dialog>

    </div>
}